<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap-large items-center">
    <h2 class="text-8xl text-center">
        Fehler <span class="text-secondary-600 font-bold">404</span>
    </h2>

    <p class="text-2xl text-center">Die Seite konnte nicht gefunden werden.</p>

    <wci-button routerLink="/" label="zurück zur Startseite" variant="secondary"
        >zurück zur Startseite</wci-button
    >
</div>

<wci-cta></wci-cta>
